
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

export default {
    data (){
        return {
            isOpenAvatarCreator: false,

            openedNavSelections: ["profile"],

            isShowOpeningVideo: false,
            isPlayOpeningVideo: false,

            myBGM: null,
            bgmGestureHandler: null,
            isUserMuted: false,
            isSystemMuted: false,
            isFullscreen: false,
            isOpenHelpDesk: false,
            isOpenProfile: true,
            isOpenRank: false,
            isOpenChatArea: false,
            isMobileLandscape: false,
            isShowFullNav: true,
            isZoneSelected: false,

            current360: "lobby_flat",
            loaded360: "",

            currentPopupItem: null,

            expoItems: null,
            privateAccessItems: [],
            systemMutedItems: ["lobby_video", "live_stream"],

            isLoadingJson: true,
            isLoadingSetting: true,

            agendaOnDemandItem: null,

            loginStreak: null,
            placardItem: null,
            jukeboxBackgrounds: [],

            notificationHeight: 0,
            resizeObserver: null,
        }
    },
    computed: {
        ...mapState({
            set360Live: state => state.setting.set360,
            set360Stg: state => state.setting.set360_stg,
            settingWeek: state => state.setting.week,
            settingWeekStg: state => state.setting.week_stg,
            isPublicAccess: state => state.setting.is_public_access,
            isPublicFeedback: state => state.setting.is_public_feedback,
            notificationText: state => state.setting.notification_text,
            isShowNotification: state => state.setting.is_show_notification,
            isStampCollectable: state => state.stamp.isStampCollectable,
            isSettingReady: state => state.setting.is_setting_ready,
            peacetopiaQuoteItems: state => state.setting.peacetopia_quotes,
        }),
        ...mapGetters({
            currentPoints: "stamp/currentPoints",
        }),
        set360(){
            return process.env.isStg? this.set360Stg : this.set360Live;
        },
        currentWeek(){
            return process.env.isStg? this.settingWeekStg : this.settingWeek;
        },
        activities(){
            return [
                { slug: "jukebox", title: "Fiesta Jukebox" },
                { slug: "build_the_beat", title: "Build the Beat" },
                { slug: "chat_area", title: "Vibe Yard" },
                ...this.isPublicFeedback? [{ slug: "user_survey", title: "User Survey" }] : []
            ]
        },
        navs(){
            return [
                { name: "Home", slug: 'home' , svg: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 3.23523C8.68967 3.23523 8.3836 3.30744 8.106 3.44616L3.553 5.72316C3.38692 5.80615 3.24722 5.93374 3.14956 6.09164C3.05189 6.24953 3.0001 6.4315 3 6.61716V19.3802C2.99958 19.5508 3.04284 19.7187 3.12565 19.8679C3.20846 20.0171 3.32808 20.1427 3.47312 20.2326C3.61816 20.3225 3.78379 20.3738 3.95426 20.3816C4.12473 20.3894 4.29436 20.3534 4.447 20.2772L8.106 18.4472C8.3836 18.3084 8.68967 18.2362 9 18.2362C9.31033 18.2362 9.6164 18.3084 9.894 18.4472L14.106 20.5532C14.3836 20.6919 14.6897 20.7641 15 20.7641C15.3103 20.7641 15.6164 20.6919 15.894 20.5532L20.447 18.2762C20.6131 18.1932 20.7528 18.0656 20.8505 17.9077C20.9481 17.7498 20.9999 17.5678 21 17.3822V4.61816C21.0003 4.4476 20.9569 4.27981 20.874 4.13074C20.7911 3.98168 20.6715 3.85629 20.5265 3.76649C20.3814 3.6767 20.2159 3.62549 20.0455 3.61773C19.8751 3.60997 19.7056 3.64592 19.553 3.72216L15.894 5.55216C15.6164 5.69088 15.3103 5.76309 15 5.76309C14.6897 5.76309 14.3836 5.69088 14.106 5.55216L9.894 3.44616C9.6164 3.30744 9.31033 3.23523 9 3.23523ZM15 5.76309L15 20.7626M9 3.23523L9 18.2352" stroke="white" stroke-width="2" stroke-linecap="round"/></svg>' },
                { name: "Activities", slug: 'activities' , svg: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18V5L21 3V16M9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.3431 4.34315 15 6 15C7.65685 15 9 16.3431 9 18ZM21 16C21 17.6569 19.6569 19 18 19C16.3431 19 15 17.6569 15 16C15 14.3431 16.3431 13 18 13C19.6569 13 21 14.3431 21 16Z" stroke="white" stroke-width="2" stroke-linecap="round"/></svg>' },
                { name: "Agenda", slug: 'agenda' , svg: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.0001 4.99915V6.99937M13.0001 17.0005V19.0007M13.0001 10.9998V13.0001M1.99927 8.9996C2.79498 8.9996 3.5581 9.31571 4.12076 9.87838C4.68341 10.4411 4.99951 11.2042 4.99951 11.9999C4.99951 12.7957 4.68341 13.5588 4.12076 14.1215C3.5581 14.6842 2.79498 15.0003 1.99927 15.0003V17.0005C1.99927 17.531 2.21 18.0398 2.5851 18.4149C2.9602 18.79 3.46895 19.0007 3.99943 19.0007H20.0007C20.5312 19.0007 21.0399 18.79 21.415 18.4149C21.7901 18.0398 22.0009 17.531 22.0009 17.0005V15.0003C21.2052 15.0003 20.442 14.6842 19.8794 14.1215C19.3167 13.5588 19.0006 12.7957 19.0006 11.9999C19.0006 11.2042 19.3167 10.4411 19.8794 9.87838C20.442 9.31571 21.2052 8.9996 22.0009 8.9996V6.99937C22.0009 6.46888 21.7901 5.96011 21.415 5.585C21.0399 5.20988 20.5312 4.99915 20.0007 4.99915H3.99943C3.46895 4.99915 2.9602 5.20988 2.5851 5.585C2.21 5.96011 1.99927 6.46888 1.99927 6.99937V8.9996Z" stroke="white" stroke-width="2" stroke-linecap="round"/></svg>' },
                { name: "Refer a Friend", slug: 'reference' , svg: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.0001 19.0005V22.0007M4.99927 9.99979V11.9999C4.99927 13.8566 5.73685 15.6372 7.04975 16.9501C8.36266 18.2629 10.1433 19.0005 12.0001 19.0005C13.8568 19.0005 15.6375 18.2629 16.9504 16.9501C18.2633 15.6372 19.0009 13.8566 19.0009 11.9999V9.99979M12.0001 1.99915C13.6571 1.99915 15.0004 3.3424 15.0004 4.99939V11.9999C15.0004 13.6569 13.6571 15.0002 12.0001 15.0002C10.343 15.0002 8.99972 13.6569 8.99972 11.9999V4.99939C8.99972 3.3424 10.343 1.99915 12.0001 1.99915Z" stroke="white" stroke-width="2" stroke-linecap="round"/></svg>' },
                { name: "Leaderboards", slug: 'leaderboard' , svg: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.99991 14.6603V16.2864C9.99613 16.6291 9.90438 16.965 9.73347 17.262C9.56255 17.559 9.31819 17.8072 9.02383 17.9826C8.39892 18.4454 7.89058 19.0477 7.5392 19.7414C7.18781 20.4351 7.00308 21.2013 6.99967 21.9789M14.0002 14.6603V16.2864C14.004 16.6291 14.0958 16.965 14.2667 17.262C14.4376 17.559 14.6819 17.8072 14.9763 17.9826C15.6012 18.4454 16.1096 19.0477 16.4609 19.7414C16.8123 20.4351 16.9971 21.2013 17.0005 21.9789M18.0005 8.99971H19.5007C20.1638 8.99971 20.7997 8.73629 21.2686 8.26741C21.7375 7.79854 22.0009 7.1626 22.0009 6.49951C22.0009 5.83641 21.7375 5.20048 21.2686 4.7316C20.7997 4.26272 20.1638 3.99931 19.5007 3.99931H18.0005M18.0005 8.99971C18.0005 10.5911 17.3684 12.1174 16.243 13.2427C15.1177 14.368 13.5915 15.0002 12.0001 15.0002C10.4086 15.0002 8.8824 14.368 7.75709 13.2427C6.63178 12.1174 5.99959 10.5911 5.99959 8.99971M18.0005 8.99971V2.99923C18.0005 2.73399 17.8952 2.47961 17.7076 2.29206C17.5201 2.10451 17.2657 1.99915 17.0005 1.99915H6.99967C6.73443 1.99915 6.48006 2.10451 6.2925 2.29206C6.10495 2.47961 5.99959 2.73399 5.99959 2.99923V8.99971M5.99959 8.99971H4.49947C3.83637 8.99971 3.20044 8.73629 2.73156 8.26741C2.26268 7.79854 1.99927 7.1626 1.99927 6.49951C1.99927 5.83641 2.26268 5.20048 2.73156 4.7316C3.20044 4.26272 3.83637 3.99931 4.49947 3.99931H5.99959M3.99943 22.0007H20.0007" stroke="white" stroke-width="2" stroke-linecap="round"/></svg>' },
                { name: "Support", slug: 'support' , svg: '<svg width="24" height="24" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.25 0.5C0.8375 0.5 0.5 0.885714 0.5 1.35714V4.35714C0.5 4.82857 0.8375 5.21429 1.25 5.21429H2L3.5 6.5V5.21429H5.75C6.1625 5.21429 6.5 4.82857 6.5 4.35714V1.35714C6.5 0.885714 6.1625 0.5 5.75 0.5H1.25Z" stroke="white" stroke-linejoin="round"/><circle cx="6.79688" cy="7.85938" r="1.5" stroke="white"/><path d="M4.29688 12.4531C4.29688 10.6531 5.43324 9.45312 6.79688 9.45312C8.16051 9.45312 9.29688 10.6531 9.29688 12.4531" stroke="white" stroke-linecap="round"/></svg>' },
            ]
        },
        peacetopiaQuotes(){
            return this.peacetopiaQuoteItems?.[this.currentWeek - 1] || [];
        },
        isLobbyMap(){
            return ["lobby_flat", "lobby_flat_m"].includes(this.current360);
        },
        getMy360Url(){
            const media = this.wellnessToMedia(this.current360);
            const suffix = `#media=${ media }${ this.current360 == 'lobby_flat' && /Mobi/i.test(navigator.userAgent) ? '_m' : ''}`;
            if(process.env.NODE_ENV !== "production") return `/static/ocbc360_1/index.html${ suffix }`;
            if(!this.isSettingReady) return null;
            return `/static/${ this.set360 || "ocbc360_1" }/index.html${ suffix }`;
        },
        // getMy360Url(){
        //     console.log(this.current360)
        //     if(process.env.NODE_ENV !== "production") return `/static/ocbc360_1/index.html#media=${ this.current360 }${ this.current360 == 'lobby_flat' && /Mobi/i.test(navigator.userAgent) ? '_m' : ''}`;
        //     return `/static/${ this.set360 || "ocbc360" }/index.html#media=${ this.current360 }${ this.current360 == 'lobby_flat' && /Mobi/i.test(navigator.userAgent) ? '_m' : ''}`;
        // },
        isLoading(){
            return this.isLoadingJson || this.isLoadingSetting;
        },
        isMuted(){
            if(this.isShowOpeningVideo) return true;
            return (this.isSystemMuted || this.isUserMuted)? true : false;
        },
        routeRooms(){
            return this.zones.map(zone => zone.slug);
        },
        routeWellnesses(){
            return this.zones.map(zone => zone.wellness);
        },
        layoutStyles(){
            return {
                '--notification-height': `${this.notificationHeight}px`
            }
        }
    },
    mounted(){
        if(process.env.NODE_ENV === "production"){
            debugger;
            setInterval(() => { debugger; }, 1000);
        }

        window.addEventListener("resize", this.onHandleWindowResize.bind(event, 0));
        this.onHandleWindowResize(0);

        this.onInitUser();
        const isWatchedOpeningVideo = localStorage.getItem(`${ process.env.cookieName }_opening_video`);
        // if(!isWatchedOpeningVideo) this.isShowOpeningVideo = true;

        this.onHandleRouteNav();

        this.myBGM = document.getElementById("bgm");
        this.onSyncBGM();

        this.$axios.$post("/auth/init_user", {}, this.tokenHeader).then((res) => {
            console.log("initUserCallback", res);
            this.$store.commit("stamp/setItems", res.stamps);
            if(res.setting) this.$store.commit("setting/setItem", res.setting);
            this.$store.commit("stamp/setIsStampCollectable", res.is_stamp_collectable);
            this.$store.commit("auth/updateUser", {
                ...res.state && { state: res.state },
                ...res.avatar && { avatar: res.avatar },
                ...res.avatar_url && { avatar_url: res.avatar_url },
                ...res.chat_id && { cid: res.chat_id },
                ...res.login_streak && { streak: res.login_streak?.streak },
            });
            this.loginStreak = res.login_streak;
            this.jukeboxBackgrounds = res.jukebox_backgrounds || [];
            this.isLoadingSetting = false;
        }).catch((err) => {
            console.error("initUserError", err);
            return this.onHandleApiError(err);
        });

        $crisp.push(["on", "chat:closed", (event) => {
            this.isOpenHelpDesk = false;
            this.onHandleTriggerAnalytics(`close@support`);

            $crisp.push(['do', 'chat:hide']);
        }]);

        this.$axios.get(`${ process.env.domainUrl }/static/json/expo_content.json?v=${ new Date().getTime() }`).then(res => {
            // console.log(res.data);
            this.expoItems = res.data;
            this.isLoadingJson = false;
        });

        window.addEventListener("message", (event) => {
            if(event.data && event.data.title) console.log(event.data);
            let zone = _.find(this.zones, { slug: event.data.data });
            switch(event.data.title){
                case "open_360":
                    this.onClickNavItem(event.data.data?.replace(/_\d+$/, ""));
                    break;
                case "loaded_360":
                    const substringsToRemove = ["_1", "_2", "_3", "_4", "_5", "_6", "_7"];
                    const pattern = new RegExp(substringsToRemove.join("|"), "g");
                    this.loaded360 = event.data.data.replace(pattern, "");

                    if(zone && event.data.data != 'lobby'){
                        this.$store.dispatch("stamp/onSubmitStamp", {
                            title: `Explore ${ zone.title }`,
                            room: zone.title
                        });
                    }

                    if(this.agendaOnDemandItem){
                        this.currentPopupItem = "on_demand";
                        this.agendaOnDemandItem = null;
                    }
                    break;
                case "open_popup":
                    if(event.data.data == "support"){
                        if(this.isOpenHelpDesk){
                            $crisp.push(["do", "chat:hide"]);
                        }else{
                            $crisp.push(["do", "chat:open"]);
                            $crisp.push(["do", "chat:show"]);
                        }

                        this.isOpenHelpDesk = !this.isOpenHelpDesk;
                        this.onHandleTriggerAnalytics(`${ this.isOpenHelpDesk? 'open' : 'close' }@support`);
                    }else{
                        // if(event.data.data == "live_stream" || event.data.data == "on_demand"){
                        //     console.log(this.loaded360)
                        //     this.onHandleTriggerAnalytics(`open@${ event.data.data }@${ this.wellnessToRoom(this.loaded360) }`);
                        // }else{
                            this.onHandleTriggerAnalytics(`open@${ event.data.data }`);
                        // }

                        if(this.privateAccessItems.includes(event.data.data) && !this.isPublicAccess){
                            return this.onShowStayTuneAlert();
                        }
                        this.currentPopupItem = event.data.data;
                    }
                    break;
                case "open_placard":
                    const placard = this.onHandlePlacardItem(event.data.data, event.data.extra_data);
                    if(placard){
                        this.placardItem = placard;

                        // this.$store.dispatch("stamp/onSubmitStamp", {
                        //     title: `Placard ${ placard.key }`,
                        //     room: zone?.title
                        // });

                        this.onHandleTriggerAnalytics(`open@placard@${ placard.zone }@${ placard.key }`);
                    }
                    break;
                case "scavenger_hunt":
                    if(event.data.extra_data >= 1 && event.data.extra_data <= 5 ){
                        this.onHandleTriggerAnalytics(`scavenger_hunt_${ event.data.extra_data }@${ event.data.data }`);
                        this.$store.dispatch("stamp/onSubmitStamp", {
                            title: `Scavenger Hunt ${ event.data.extra_data } (Set ${ this.set360.replace('ocbc360_', '') })`,
                            room: zone.title
                        });
                    }
                    break;
                case "game_stamp":
                    this.$store.commit("stamp/addItem", event.data.data);
                    break;
                case "close_game":
                    this.onHandleTriggerAnalytics(`close@${ this.currentPopupItem }`);
                    this.currentPopupItem = null;
                    break;
            }
        });
    },
    methods: {
        onHandleWindowResize(delayTime){
            setTimeout(() => {
                const $win = $(window);
                const winW = $win.width();
                const winH = $win.height();

                this.isMobileLandscape = winW > winH && /Mobi/i.test(navigator.userAgent);
                this.$store.commit("context/setItem", { winW, winH });
            }, delayTime);
        },
        onInitUser(){
            if(this.user){
                this.$socket.disconnect();
                this.$socket.io.opts.query = { token : this.user.token };
                this.$socket.connect();
                this.$socket.emit("getSetting");

                if(!this.user.avatar || !this.user.avatar_url) this.isOpenAvatarCreator = true;

                $crisp.push(["set", "user:nickname", [this.user.email]]);
            }
        },
        onHandlePlacardItem(zone, key){
            if(!zone || key === undefined || key === null) return null;

            if(zone == "peacetopia"){
                const quote = this.peacetopiaQuotes[parseInt(key) - 1];
                if(!quote) return null;
                return { zone, key, title: quote, desc: "Small steps. A brighter you." };
            }

            const items = this.expoItems?.placards?.[zone] || {};
            const item = items[key];
            if(!item) return null;
            return { zone, key, title: item.title, desc: item.desc, total: Object.keys(items).filter(item => !isNaN(item)).length };
        },
        onSyncBGM(){
            if(!this.myBGM) return;

            if(!this.myBGM.getAttribute("src")){
                this.myBGM.setAttribute("src", this.formattedAssetUrl(`/static/musics/bgm.mp3`));
                this.myBGM.loop = true;
                this.myBGM.volume = 0.5;
            }

            this.myBGM.muted = this.isMuted;
            if(this.isMuted) return;

            const playPromise = this.myBGM.play();
            if(playPromise?.catch){
                playPromise.then(() => {
                    this.onRemoveBGMGesture();
                }).catch(err => {
                    console.error(err);
                    if(err?.name != "AbortError") this.onWaitBGMGesture();
                });
            }
        },
        onWaitBGMGesture(){
            if(this.bgmGestureHandler) return;

            this.bgmGestureHandler = () => {
                if(this.isMuted || !this.myBGM) return;
                this.myBGM.play().then(() => this.onRemoveBGMGesture()).catch(err => console.error(err));
            };

            ["pointerdown", "touchend", "keydown"].forEach(type => {
                window.addEventListener(type, this.bgmGestureHandler);
            });
        },
        onRemoveBGMGesture(){
            if(!this.bgmGestureHandler) return;

            ["pointerdown", "touchend", "keydown"].forEach(type => {
                window.removeEventListener(type, this.bgmGestureHandler);
            });
            this.bgmGestureHandler = null;
        },
        onHandleLoadMap(){
            this.loaded360 = this.current360;
        },
        onHandleRouteNav(){
            const currentRoutePath = this.$route.path.replace(/\//g, "");
            if(this.routeRooms.includes(currentRoutePath)){
                this.current360 = this.roomToWellness(currentRoutePath);
            }
        },
        onClickPlayOpeningVideo(isSound){
            this.isPlayOpeningVideo = true;
            localStorage.setItem(`${ process.env.cookieName }_opening_video`, true);

            this.isUserMuted = !isSound;
            $("#opening_video").prop("muted", !isSound);
            $("#opening_video").trigger("play");

            $("#opening_video").bind("ended", () => {
                console.log("Opening Video Ended");
                this.isShowOpeningVideo = false;
                this.isPlayOpeningVideo = false;
            });

            this.onHandleTriggerAnalytics(`enable_sound@${ isSound }`);
        },
        onClickSkipOpeningVideo(){
            if(!this.isPlayOpeningVideo) this.isUserMuted = false;

            this.isShowOpeningVideo = false;
            this.isPlayOpeningVideo = false;
            localStorage.setItem(`${ process.env.cookieName }_opening_video`, true);
            this.onHandleTriggerAnalytics(`skip@opening_video`);
        },
        onClickHiddenRoomBtn(){
            const room = document.getElementById("hidden_room").dataset.room;
            this.$router.push({ path: `/${ room }/` });
            this.onHandleTriggerAnalytics(`open@${ room }@ticker_tape`);
        },
        onClickHiddenPopupBtn(){
            const hiddenItem = document.getElementById("hidden_popup");

            if(hiddenItem.dataset.popup == "user_survey"){
                this.onClickNavItem("user_survey");
            }else{
                this.currentPopupItem = hiddenItem.dataset.popup;
                this.onHandleTriggerAnalytics(`open@${ this.currentPopupItem }@${hiddenItem.dataset?.source || "ticker_tape" }`);
            }
        },
        onClickNavItem(item){
            if(["mute", "unmute", "fullscreen", "minimize"].includes(item)){
                this.onHandleTriggerAnalytics(`trigger@${ item }`);
            }else if(["profile", "activities", "settings"].includes(item)){

            }else if(item == "logout"){
                this.onHandleTriggerAnalytics(`logout`);
            }
            else if(item == 'home'){
                if(this.routeRooms.includes("lobby")){
                    this.current360 = this.roomToWellness("lobby") + (/Mobi/i.test(navigator.userAgent) ? '_m' : '');
                    this.openedNavSelections = this.openedNavSelections.filter(selection => selection != "activities");
                    this.$router.push({ path: `/lobby/` });
                }

                this.onHandleTriggerAnalytics(`open@lobby`);
            }else{
                if(this.routeRooms.includes(item)){
                    this.current360 = this.roomToWellness(item);
                    this.openedNavSelections = this.openedNavSelections.filter(selection => selection != "activities");
                    this.$router.push({ path: `/${ item }/` });
                }else if(this.routeWellnesses.includes(item)){
                    this.current360 = item;
                    this.openedNavSelections = this.openedNavSelections.filter(selection => selection != "activities");
                    this.$router.push({ path: `/${ this.wellnessToRoom(item) }/` });
                }

                this.onHandleTriggerAnalytics(`open@${ item }`);
            }

            if(this.privateAccessItems.includes(item) && !this.isPublicAccess) return this.onShowStayTuneAlert();

            const element = document.documentElement;
            switch(item){
                case "support": 
                    if(this.isOpenHelpDesk){
                        $crisp.push(["do", "chat:hide"]);
                    }else{
                        $crisp.push(["do", "chat:open"]);
                        $crisp.push(["do", "chat:show"]);
                    }

                    this.isOpenHelpDesk = !this.isOpenHelpDesk;
                    this.onHandleTriggerAnalytics(`${ this.isOpenHelpDesk? 'open' : 'close' }@support`);
                    break;
                case "profile":
                case "activities":
                case "settings":
                    if(this.openedNavSelections.includes(item)){
                        this.openedNavSelections = this.openedNavSelections.filter(selection => selection != item);
                        this.onHandleTriggerAnalytics(`close@${ item }`);
                    }else{
                        this.openedNavSelections.push(item);
                        this.onHandleTriggerAnalytics(`open@${ item }`);
                    }
                    break;
                case "zones":
                case "agenda":
                case "leaderboard":
                case "reference":
                case "chat":
                case "jukebox":
                case "build_the_beat":
                case "bonus_code":
                    this.currentPopupItem = item;
                    break;
                case "chat_area":
                    this.isOpenChatArea = true;
                    break;
                case "user_survey":
                    if(!this.isPublicFeedback){
                        return this.$swal({
                            icon: "info",
                            title: "The user survey goes live on 29 September. See you then!",
                            // text: "",
                        });
                    }
                    this.currentPopupItem = item;
                    break;
                case "mute":
                case "unmute":
                    this.isUserMuted = !this.isUserMuted;
                    break;
                case "fullscreen":
                    if(element.requestFullscreen) {
                        element.requestFullscreen();
                    }else if(element.mozRequestFullScreen) {
                        element.mozRequestFullScreen();
                    }else if(element.webkitRequestFullscreen) {
                        element.webkitRequestFullscreen();
                    }else if(element.msRequestFullscreen) {
                        element.msRequestFullscreen();
                    }
                    this.isFullscreen = true;
                    break;
                case "minimize":
                    if(document.exitFullscreen) {
                        document.exitFullscreen();
                    }else if(document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    }else if(document.webkitExitFullscreen) {
                        document.webkitExitFullscreen();
                    }
                    this.isFullscreen = false;
                    break;
                case "logout":
                    this.$swal({
                        icon: "info",
                        title: "Are you sure?",
                        html: "<p>You will have to reactivate this device again.</p><br><i><p class='text-xs'>Logging out is only recommended for shared or unsecured devices. Otherwise, you can just close your browser window - and return any time, seamlessly.</p></i>",
                        showCancelButton: true,
                    }).then(res => {
                        if(res.isConfirmed) this.$store.dispatch("auth/onLogoutUser");
                    });
            }
        },
        onClickCustomAvatar(){
            this.isOpenAvatarCreator = true;
            this.onHandleTriggerAnalytics("open@avatar");
        },
        onShowStayTuneAlert(){
            this.$swal({
                icon: "info",
                title: "Stay tuned!",
                // text: "This will go live on 19 Oct, Wednesday.",
            });
        },
        onWinBackground(backgroundIndex) {
            if (!this.jukeboxBackgrounds.includes(backgroundIndex)) {
                this.jukeboxBackgrounds.push(backgroundIndex);
            }
        },
        startObserving() {
            const el = this.$refs.notification;
            if (!el) return;

            this.stopObserving();

            this.resizeObserver = new ResizeObserver(([entry]) => {
                this.notificationHeight = entry.target.offsetHeight;
            });

            this.resizeObserver.observe(el);
        },
        stopObserving() {
            if (this.resizeObserver) {
                this.resizeObserver.disconnect();
                this.resizeObserver = null;
            }
        }
    },
    watch: {
        "user"(){
            this.onInitUser();
        },
        "$route.path"(){
            this.onHandleRouteNav();
        },
        "currentPopupItem"(value){
            this.isSystemMuted = this.systemMutedItems.includes(value);
            if(!value) this.onHandleRouteNav();

            this.$store.commit("auth/setIsOpenLiveStream", this.currentPopupItem == 'live_stream');
        },
        "agendaOnDemandItem"(value){
            if(value){
                if(this.roomToWellness(value) == this.loaded360){
                    this.currentPopupItem = "on_demand";
                    this.agendaOnDemandItem = null;
                }else{
                    this.currentPopupItem = null;
                    this.current360 = this.roomToWellness(value);
                    this.$router.push({ path: `/${ value }/` });
                }
            }
        },
        isShowNotification: {
            immediate: true,
            handler(isVisible){
                if (isVisible) {
                    this.$nextTick(() => {
                        this.startObserving();
                    });
                } else {
                    this.stopObserving();
                    this.notificationHeight = 0; 
                }
            }
        },
        "isMuted"(){
            this.onSyncBGM();
        }
    },
    beforeDestroy(){
        this.stopObserving();
        this.onRemoveBGMGesture();
    }
}
